// extracted by mini-css-extract-plugin
module.exports = {"container":"_8ec6db9","inline":"_9c24121"};